export default __webpack_public_path__ + "static/media/ics2026.7f4b1c8f.svg";